export const CATEGORY_LANDING_PAGES = [
  "bathroom-faucets",
  "toilet-seats-bidet-seats",
  "toilets",
  "showers",
  "bathtubs",
]
